module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-4-e9cdad90b43d80e854bb9d6020119ab0.jpg";